import { JourneysLegacyAuthRefreshRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/confirm_account/$')({
  component: JourneysLegacyAuthRefreshRoute,
});
